// extracted by mini-css-extract-plugin
export var settingsList = "_3o-0";
export var settingsRow = "_3o-1";
export var warningDot = "_3o-2";